import { observe } from "selector-observer";

observe(".medical-services-card__button", {
    add(element) {
        const cardInfo = element.parentElement.parentElement.querySelector(".card-info");

        if (!cardInfo) return

        element.addEventListener("click", () => {
            if (cardInfo.classList.contains("hidden")) {
                cardInfo.classList.remove("hidden");
                element.setAttribute("aria-expanded", "true");
            } else {
                cardInfo.classList.add("hidden");
                element.setAttribute("aria-expanded", "false");
            }
        });
    },
});
